import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type {
  PaginatedUserList,
  User,
  UserCreateUpdate,
  UserGroup,
} from "../../app/generated-axios-client";

export interface UserManagementState {
  list: PaginatedUserList;
  user: User | null;
  availableGroups: UserGroup[];
}

const initialState: UserManagementState = {
  list: {
    pagination: {
      total_items: 0,
      total_pages: 0,
      current_page: 0,
      per_page: 0,
    },
    results: [],
  },
  user: null,
  availableGroups: [],
};

export const userManagementSlice = createSlice({
  name: "userManagement",
  initialState,
  reducers: {
    addUserList: (state, action: PayloadAction<PaginatedUserList>) => {
      state.list = action.payload;
    },
    storeUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    removeUser: (state) => {
      state.user = null;
    },
    storeGroups: (state, action: PayloadAction<UserGroup[]>) => {
      state.availableGroups = action.payload;
    },
    addOrUpdateUser: (_state, _action: PayloadAction<UserCreateUpdate>) => {},
    deleteUser: (_state, _action: PayloadAction<number>) => {},
    deactivateUser: (_state, _action: PayloadAction<number>) => {},
    reactivateUser: (_state, _action: PayloadAction<number>) => {},
  },
});

export const userManagementActions = userManagementSlice.actions;
export const userManagementReducer = userManagementSlice.reducer;
export default userManagementReducer;
